import React from 'react';
import { motion } from 'framer-motion';
import CTAButton from './CTAButton';
const scrollToPricing = () => {
  const pricingSection = document.getElementById('pricing');
  if (pricingSection) {
    pricingSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};
const MethodSection: React.FC = () => {
  return <section className="w-full bg-white py-16" data-id="element-114">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-116">
          <span className="inline-block bg-primary/10 text-primary font-medium px-4 py-2 rounded-full mb-4" data-id="element-117">
            ✨ Presentación del método
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-secondary mb-2" data-id="element-118">
            Reto 21 Días Sin Azúcar
          </h2>
          <p className="text-lg text-gray-600" data-id="element-119">
            Diseñado especialmente para mujeres que quieren:
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-120">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-background p-6 rounded-lg shadow-md" data-id="element-121">
            <p className="mb-3" data-id="element-122">
              ✓ Recuperar su cuerpo después de años de lucha.
            </p>
            <p className="mb-3" data-id="element-123">✓ Sentirse más ligeras y desinflamadas.</p>
            <p className="mb-3" data-id="element-124">✓ Tener energía real desde la mañana.</p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-background p-6 rounded-lg shadow-md" data-id="element-125">
            <p className="mb-3" data-id="element-126">
              ✓ Disfrutar de una piel más bonita y luminosa.
            </p>
            <p className="mb-3" data-id="element-127">✓ Volver a sentirse orgullosas en el espejo.</p>
          </motion.div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="bg-secondary/5 p-8 rounded-xl mb-10 text-center" data-id="element-128">
          <p className="text-lg mb-2" data-id="element-129">Sin seguimiento.</p>
          <p className="text-lg mb-2" data-id="element-130">Sin comunidades.</p>
          <p className="text-lg mb-2" data-id="element-131">Sin complicarte la vida.</p>
          <p className="text-xl font-medium text-primary-dark mt-4" data-id="element-132">
            Solo tú, con una guía clara que funciona sí o sí.
          </p>
        </motion.div>
        <div className="flex justify-center" data-id="element-133">
          <CTAButton onClick={scrollToPricing} data-id="element-134">QUIERO MI RESET</CTAButton>
        </div>
      </div>
    </section>;
};
export default MethodSection;